import * as React from 'react'
import { useSignMessage, useAccount, useSwitchChain } from 'wagmi'
import { recoverMessageAddress } from 'viem'
import { apiUrl } from '../utils/constants.ts'

export function SignMessage({
  ChadAddress,
  sender,
  content,
  timestamp,
  chainId
}) {
  const {
    data: signMessageData,
    isLoading,
    signMessage,
    variables,
    reset
  } = useSignMessage()
  const { address, chain } = useAccount()
  const { switchChain } = useSwitchChain()

  React.useEffect(() => {
    ;(async () => {
      if (variables?.message && signMessageData) {
        const recoveredAddress = await recoverMessageAddress({
          message: variables?.message,
          signature: signMessageData
        })
        if (recoveredAddress) {
          const sendData = {
            ChadAddress,
            sender,
            content: variables?.message,
            timestamp,
            chainId
          }
          const response = await fetch(apiUrl + '/api/add', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'error',
            body: JSON.stringify(sendData)
          })
          reset()
          const messageEl = document.getElementById('message')
          if (messageEl) messageEl.value = ''
          if (response.status !== 200) {
            const { error } = await response.json()
            throw new Error(error)
          }
        }
      }
    })()
  }, [signMessageData, variables?.message])

  return (
    <section className="w-full">
      <form
        onSubmit={event => {
          event.preventDefault()
          const formData = new FormData(event.target)
          const message = formData.get('message')
          signMessage({ message })
        }}
        className="space-y-2"
      >
        <textarea
          id="message"
          name="message"
          rows="4"
          placeholder="comment"
          className="w-full text-[13px] tracking-wide text-[#f8ffe8] bg-[#1d2028] border border-[#2a2d36] focus:border-[#a135bb] rounded-[8px] px-3 py-2.5 outline-none transition-colors resize-none placeholder:text-[#919191]"
        />
        {address === undefined ? (
          <button
            type="submit"
            disabled
            className="w-full font-bold text-lg py-3 rounded-lg bg-gray-500 text-white cursor-not-allowed"
          >
            connect wallet
          </button>
        ) : chain?.id && chain.id !== chainId ? (
          <button
            type="button"
            onClick={() => switchChain({ chainId: Number(chainId) })}
            className="w-full font-bold text-lg py-3 rounded-lg bg-[#7CFC98] text-black hover:bg-[#b1ffcb]"
          >
            switch network
          </button>
        ) : (
          <button
            type="submit"
            disabled={isLoading}
            className="w-full font-bold text-lg py-3 rounded-lg bg-[#7CFC98] text-black hover:bg-[#b1ffcb]"
          >
            {isLoading ? 'posting...' : 'post reply'}
          </button>
        )}
      </form>
    </section>
  )
}
